import { Link } from 'react-router-dom';
import { Package, Download, CalendarCheck, FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';

const CATALOG_PDF = '/vdbf-full-line-catalogue.pdf';

export const CtaBand = () => {
  return (
    <section className="relative py-16 md:py-20" data-testid="cta-band-section">
      <div className="container mx-auto">
        <div className="relative rounded-[2.5rem] gradient-leaf overflow-hidden shadow-pop">
          <div className="absolute inset-0 bg-noise opacity-[0.04]" />
          <div className="absolute -top-20 -right-20 h-72 w-72 rounded-full bg-accent/30 blur-3xl" />

          <div className="relative p-8 sm:p-12 lg:p-16 grid lg:grid-cols-12 gap-10 items-center text-primary-foreground">
            <div className="lg:col-span-5">
              <div className="font-script text-2xl text-accent">next step</div>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-medium leading-tight mt-1">
                Ready to put us<br/><span className="italic font-light text-accent">on your menu?</span>
              </h2>
              <p className="mt-4 text-primary-foreground/80 max-w-md">
                Taste it, spec it, price it — however you like to start, we make the first step easy.
              </p>
            </div>

            <div className="lg:col-span-7 grid sm:grid-cols-2 gap-3">
              <Button asChild size="lg" className="h-14 rounded-2xl bg-accent text-accent-foreground hover:bg-accent/90 text-base justify-start px-6" data-testid="cta-request-samples">
                <Link to="/wholesale#request"><Package className="mr-2.5 h-5 w-5" /> Request Samples</Link>
              </Button>
              <Button asChild size="lg" className="h-14 rounded-2xl bg-primary-foreground/10 border border-primary-foreground/25 text-primary-foreground hover:bg-primary-foreground/20 text-base justify-start px-6" data-testid="cta-download-catalogue">
                <a href={CATALOG_PDF} download="VDBF-Full-Line-Catalogue.pdf" target="_blank" rel="noopener noreferrer"><Download className="mr-2.5 h-5 w-5" /> Download Catalogue</a>
              </Button>
              <Button asChild size="lg" className="h-14 rounded-2xl bg-primary-foreground/10 border border-primary-foreground/25 text-primary-foreground hover:bg-primary-foreground/20 text-base justify-start px-6" data-testid="cta-book-tasting">
                <a href="mailto:toronto@vegandanishbakery.com?subject=Book%20a%20Product%20Tasting"><CalendarCheck className="mr-2.5 h-5 w-5" /> Book a Product Tasting</a>
              </Button>
              <Button asChild size="lg" className="h-14 rounded-2xl bg-primary-foreground/10 border border-primary-foreground/25 text-primary-foreground hover:bg-primary-foreground/20 text-base justify-start px-6" data-testid="cta-request-quote">
                <Link to="/wholesale#request"><FileText className="mr-2.5 h-5 w-5" /> Request a Quote</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaBand;
